module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "grid-list-md": "",
      "text-xs-center": ""
    }
  }, [_c('v-form', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "lg6": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Region Type:")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "items": _vm.regionTypes,
      "label": "Type",
      "required": "",
      "single-line": "",
      "solo": "",
      "item-value": "text"
    },
    on: {
      "input": function($event) {
        return _vm.fncCheckTypes()
      }
    },
    model: {
      value: (_vm.globalModalParams.data.type),
      callback: function($$v) {
        _vm.$set(_vm.globalModalParams.data, "type", $$v)
      },
      expression: "globalModalParams.data.type"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg6": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Region Link:")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "items": _vm.regionParents,
      "label": "Link Under",
      "required": "",
      "item-value": "id",
      "autocomplete": "",
      "single-line": "",
      "solo": ""
    },
    model: {
      value: (_vm.globalModalParams.data.parent),
      callback: function($$v) {
        _vm.$set(_vm.globalModalParams.data, "parent", $$v)
      },
      expression: "globalModalParams.data.parent"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg6": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Region Name:")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Region Name",
      "required": "",
      "single-line": "",
      "solo": ""
    },
    model: {
      value: (_vm.globalModalParams.data.name),
      callback: function($$v) {
        _vm.$set(_vm.globalModalParams.data, "name", $$v)
      },
      expression: "globalModalParams.data.name"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg6": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Region Description:")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Region Description",
      "required": "",
      "single-line": "",
      "solo": ""
    },
    model: {
      value: (_vm.globalModalParams.data.description),
      callback: function($$v) {
        _vm.$set(_vm.globalModalParams.data, "description", $$v)
      },
      expression: "globalModalParams.data.description"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "pl-4 pr-1 pb-4 buttonHolder"
  }, [_c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('v-btn', {
    staticClass: "text-xs-right cancelButton",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fncHideModal.apply(null, arguments)
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), (_vm.runAdd) ? _c('v-progress-circular', {
    staticClass: "pt-3 loginLoader",
    attrs: {
      "indeterminate": "",
      "width": 3,
      "size": 20,
      "color": "grey"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.runAdd) ? _c('v-btn', {
    staticClass: "text-xs-right",
    attrs: {
      "color": "success"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fncEditRegion()
      }
    }
  }, [_vm._v("Update")]) : _vm._e(), _vm._v(" "), _c('small', [_vm._v("* The button will activate once all required fields have been completed.")])], 1)])], 1)], 1)], 1)
},staticRenderFns: []}